import {Component} from 'react';
import PropTypes from 'prop-types';
import {Step} from 'semantic-ui-react';
import {push} from 'react-router-redux';
import connected from '../connected';

export class Navigation extends Component {
  static propTypes = {
    propertyId: PropTypes.number.isRequired,
    pathname: PropTypes.string.isRequired,
    reportType: PropTypes.shape({value: PropTypes.string.isRequired}).isRequired,
    dispatch: PropTypes.func.isRequired,
    actionCreators: PropTypes.object.isRequired,
  };

  onComparableSalesClick = (event) => {
    const {propertyId, dispatch, reportType: {value: reportType}} = this.props;
    dispatch(push(`/properties/${propertyId}/${reportType}/comparable_sales`));
    event.preventDefault();
  };

  onComparableRentalsClick = (event) => {
    const {propertyId, dispatch, reportType: {value: reportType}} = this.props;
    dispatch(push(`/properties/${propertyId}/${reportType}/comparable_rentals`));
    event.preventDefault();
  };

  onComparableListingsClick = (event) => {
    const {propertyId, dispatch, reportType: {value: reportType}} = this.props;
    dispatch(push(`/properties/${propertyId}/${reportType}/comparable_listings`));
    event.preventDefault();
  };

  onCustomiseClick = (event) => {
    const {propertyId, dispatch, reportType: {value: reportType}} = this.props;
    dispatch(push(`/properties/${propertyId}/${reportType}/customise`));
    event.preventDefault();
  };

  onFinaliseClick = (event) => {
    const {propertyId, actionCreators, dispatch} = this.props;
    dispatch(actionCreators.navigateToFinalise(propertyId));
    event.preventDefault();
  };

  isCustomiseAvailable = function () {
    const {reportType: {value: reportType}} = this.props;
    return reportType !== 'soi';
  };

  isComparableListingsAvailable = function () {
    const {reportType: {value: reportType}} = this.props;
    return reportType === 'cma';
  };

  isComparableSalesAvailable = function () {
    const {reportType: {value: reportType}} = this.props;
    return reportType !== 'rental';
  };

  isComparableRentalsAvailable = function () {
    const {reportType: {value: reportType}} = this.props;
    return reportType === 'rental';
  };

  render() {
    const {
      propertyId,
      pathname,
      reportType: {value: reportType},
    } = this.props;

    return (
      <Step.Group fluid>
        {this.isComparableSalesAvailable() && (
          <Step active={`#/properties/${propertyId}/${reportType}/comparable_sales` === `#${pathname}`} onClick={this.onComparableSalesClick}>
            <Step.Content title="Comparable Sales"/>
          </Step>
        )}
        {this.isComparableListingsAvailable() && (
          <Step active={`#/properties/${propertyId}/${reportType}/comparable_listings` === `#${pathname}`} onClick={this.onComparableListingsClick}>
            <Step.Content title="Comparable Listings"/>
          </Step>
        )}
        {this.isComparableRentalsAvailable() && (
          <Step active={`#/properties/${propertyId}/${reportType}/comparable_rentals` === `#${pathname}`} onClick={this.onComparableRentalsClick}>
            <Step.Content title="Comparable Rentals"/>
          </Step>
        )}
        {this.isCustomiseAvailable() && (
          <Step active={`#/properties/${propertyId}/${reportType}/customise` === `#${pathname}`} onClick={this.onCustomiseClick}>
            <Step.Content title="Customise Report"/>
          </Step>
        )}
        <Step active={`#/properties/${propertyId}/${reportType}/finalise` === `#${pathname}`} onClick={this.onFinaliseClick}
              disabled={`#/properties/${propertyId}` === `#${pathname}`}>
          <Step.Content title="Final Preview"/>
        </Step>
      </Step.Group>
    );
  }
}

export default connected(Navigation);